import { Flex } from '@atlaskit/primitives';

import { type FunctionComponent, useEffect } from 'react';
import Header from './Header/Header';
import Description from './Description';
import Warning from './Warning';
import { useInfo, useToken } from '../../Flow/ConsentContextProvider';
import { useUser } from '#definitions/user';
import { defineMessages, useIntl } from 'react-intl';

const AppLinks: FunctionComponent = () => {
  const { customer, cloudId, clientName } = useToken();
  const { siteName } = useInfo();
  const user = useUser();
  const intl = useIntl();
  const customerName = determineCustomerName(customer);

  useEffect(() => {
    document.title = intl.formatMessage(messages.documentTitle, {
      customerName,
      clientName,
    });
  }, [clientName, customer]);

  return (
    <Flex gap="space.400" direction="column" wrap="wrap" alignItems="start">
      <Flex alignItems="center" direction="column" gap="space.400">
        <Header customer={customerName} />
        <Description
          url={siteName ?? `<${cloudId}>`}
          userFullName={user?.name || 'null'}
          appName={customerName}
        />
        <Warning appName={customerName} />
      </Flex>
    </Flex>
  );
};

function determineCustomerName(customer: string | null | undefined): string {
  switch (customer) {
    case 'jira':
      return 'Jira';
    case 'confluence':
      return 'Confluence';
    default:
      return 'Unknown';
  }
}

const messages = defineMessages({
  documentTitle: {
    id: 'applinks.documentTitle',
    defaultMessage: 'Welcome to {customerName} - {clientName}',
    description:
      'The document title that acts as the tab name. {customerName} is either Confluence or Jira.',
  },
});

export default AppLinks;
